import { localizeMonth } from "../i18n";

const formatMonthAndYear = (date: Date, language: string) => (
  `${localizeMonth(date.getMonth(), language)} ${date.getFullYear()}`
);

export default formatMonthAndYear;
